// MessagesMessageId.jsx
import React from 'react';

import MongoObjectIdMatcher from '../component/MongoObjectIdMatcher.jsx';
import Redirect from '../container/Redirect.js';
import { reactRouterNoindexLoader } from '../resource/reactRouterNoindexLoader.js';

export const loader = reactRouterNoindexLoader;

const MessagesMessageIdRoute = () => {
  return (
    <MongoObjectIdMatcher paramKeys={['messageId']}>
      <Redirect to="/message/:messageId" />
    </MongoObjectIdMatcher>
  );
};

export default MessagesMessageIdRoute;
